import { createRef } from 'react';

import { RefType } from 'components/modules/PlanExpirationHandler';

export const planExpModalRef = createRef<RefType>();
